export default {
  SET_ASETS (state, aset) {
    state.terms = aset.terms
    state.asets = aset.asets
    state.total = aset.total
    state.max_range = aset.rangeTotalMax
    state.current_page = aset.current_page
    state.from = aset.from
    state.last_page = aset.last_page
    state.per_page = aset.per_page
    state.to = aset.to
    state.total_page = aset.total_page
  },

  SET_RANGE (state, range) {
    state.state_range = range
  },
  UPDATE_ASET_FILTER (state, filter) {
    state.filter = filter
  },
  SET_NULL_TASKS (state) {
    state.asets = []
  },

  // TAG
    SET_TAGS (state, tags) {
      state.tags = tags
    },
    ADD_TAG (state, item) {
      state.tags.push(item)
    },
    UPDATE_TAGS (state, payload) {
      state.asets.find((aset) => aset.id === payload.id).tags = payload.tags
    },
  //

  // AKUMULASI
    SET_AKUMULASI (state, akumulasi) {
      state.akumulasis = []
      state.akumulasis = akumulasi.akumulasi_list
      state.akumulasi_total = akumulasi.akumulasi_total
    },
    ADD_AKUMULASI (state, item) {
      state.akumulasis.push(item)
      state.akumulasi_total = state.akumulasi_total + item.task_total
    },
    REMOVE_AKUMULASI (state, item) {
      const ItemIndex = state.akumulasis.findIndex((p) => p.id === item.id)
      state.akumulasis.splice(ItemIndex, 1)
      state.akumulasi_total = state.akumulasi_total - item.task_total
    },
    RESTORE_AKUMULASI (state, item) {
      const ItemIndex = state.akumulasis.findIndex((p) => p.id === item.id)
      state.akumulasis.splice(ItemIndex, 1)
      state.akumulasi_total = state.akumulasi_total + item.task_total
    },
}
